export default {
  'profile.updatesuccess': 'Il tuo profilo è stato aggiornato correttamente',
  'profile.insertsuccess': 'Il tuo profilo è stato creato correttamente',
  'profile.search': 'Cerca',
  'profile.oldpassword': 'Password Vecchio',
  'profile.newpassword': 'Password Nuovo',
  'profile.logo': 'LOGO',
  'profile.workinghours': 'Ore Lavorative',
  'profile.nationalcardfile': 'File della Carta Nazionale',
  'profile.addfile': 'Aggiungi File',
  'profile.editinformation': 'Modifica le Informazioni del Profilo',
  'profile.email': 'Email',
  'profile.weekdays': 'Giorni della Settimana',
  'profile.close': 'Chiudi',
  'profile.savechanges': 'Salva le Modifiche',
  'profile.deleteconfirmation': 'Sei sicuro di cancellare',
  'profile.rolename': 'Nome del Ruolo',
  'profile.register': 'Registrati',
  'profile.delete': 'Elimina',
  'profile.addemployee': 'Aggiungi Nuovo Dipendente',
  'profile.deleteemployee': 'Elimina Dipendente',
  'profile.cancel': 'Cancella',
  'profile.number': 'Numero',
  'profile.fromtime': 'Dalle Ore',
  'profile.totime': 'Alle Ore',
  'profile.setworkinghours': "Imposta l'Orario di Lavoro",
  'profile.phone': 'Telefono ',
  'profile.selectyear': "Seleziona l'Anno",
  'profile.selectmonth': 'Seleziona il Mese',
  'profile.selectday': 'Seleziona il Giorno',
  'profile.address': 'Indirizzo ',
  'profile.companyname': "Nome dell'Azienda",
  'profile.englishcompanyname': "Nome dell'Azienda in Inglese",
  'profile.persiancompanyname': "Nome dell'Azienda in Persiana",
  'profile.removeaddress': "Elimina l'Indirizzo",
  'profile.moreaddress': "Aggiungi l'Indirizzo",
  'profile.removephone': 'Elimina il Telefono',
  'profile.addphone': 'Aggiungi il Telefono',
  'profile.registercode': 'Registra il Codice',
  'profile.managername': 'Nome Manager /Agente(Necessaria)',
  'profile.businessmanagername': 'Nome di Manager',
  'profile.type': 'Tipo di Affari(Necessaria)',
  'profile.businesstype': 'Tipo di Affari',
  'profile.licensefile': 'File di Licenza',
  'profile.updatepassword': 'Per Favore aggiorna la password per continuare',
  'profile.editprofile': 'MODIFICA IL PROFILO AZIENDALE',
  'profile.individualprofile': 'MODIFICA PROFILO',
  'profile.inviteemployee': 'Invita un Dipendente',
  'profile.change': 'Modifica',
  'profile.firstname': 'Nome',
  'profile.lastname': 'Cognome',
  'profile.mobile': 'Cellulare',
  'profile.nationalcode': 'Codice Nazionale',
  'profile.password': 'Password',
  'profile.username': 'UserName',
  'profile.username/email': 'UserName / Email',
  'profile.gender': 'Sesso',
  'profile.birthdate': 'Data di Nascita',
  'profile.selectavatar': 'Seleziona Avatar',
  'profile.adminitstrator': 'amministratore',
  'profile.book/reserve': 'I miei ordini',
  'profile.businessbooking': 'I miei ordini',
  'profile.changepassword': 'Cambia la Password',
  'profile.editpersonalprofile': 'Modifica Profilo',
  'profile.onlinesupport': 'Supporto online',
  'profile.employee': 'Dipendente',
  'profile.addprofile': 'AGGIUNGI NUOVO PROFILO AZIENDALE',
  'profile.addbusiness': 'AGGIUNGI BUSINESS',
  'profile.encompanyname': 'Nome della società inglese(Necessaria)',
  'profile.facompanyname': "Nome dell'azienda locale(Necessaria)",
  'profile.myProfile': 'MIO PROFILO',
  'profile.textProfile':
    'In questa sezione puoi vedere le informazioni del tuo profilo',
  'profile.employeemanagement': 'Gestione dei Dipendenti',
  'profile.airlinequota': 'Quota compagnia aerea',
  'profile.signiture': 'FIRMA DEL PROFILO',
  'profile.addsigniture': 'SALVA FIRMA',
  'profile.quotaadd': 'Quota aggiunta correttamente',
  'profile.signout': 'Logout',
  'profile.signituresave': 'Firma salvata correttamente',
  'profile.signitureerror': 'Per favore riprova',
  'profile.profiletype': 'SELEZIONA IL TIPO DI PROFILO',
  'profile.profilsend': '',
  '': 'Il profilo è stato inviato per la verifica. I risultati saranno annunciati presto',
  'profile.suspend': 'SOSPESO',
  'profile.nationalid': 'ID Nazionale(Necessaria)',
  'profile.activitycode': 'Codice Attività(Necessaria)',
  'profile.economiccode': 'Codice Economico(Necessaria)',
  'profile.businessnationalid': 'ID Nazionale',
  'profile.businessactivitycode': 'Codice Attività',
  'profile.businesseconomiccode': 'Codice Economico',
  'profile.choosegateway': 'Scegli Gateway',
  'profile.testconnection': 'Prova la Connessione',
  'profile.savesigniture': 'Salva Firma',
  'profile.signitureping': 'Gateway Pinged Successfully',
  'profile.country': 'Paese',
  'profile.city': 'Città',
  'profile.role': 'Ruolo',
  'profile.whoareyou': 'Tu chi sei?',
  'profile.license': 'Licenza',
  'profile.viewlicense': 'Visualizza licenze',
  'profile.addlicense': 'Aggiungi Licenza',
  'profile.removelicense': 'Rimuovi licenza',
  'profile.licensetype': 'Tipo',
  'profile.upload': 'Carica',
  'profile.completeprofilepoint':
    'Per guadagnare punti, completa il tuo profilo per favore',
  'profile.licenseno': 'Numero di Licenza',
  'profile.addresswithoutindex': 'Indirizzo',
  'profile.phonewithoutindex': 'Telefono',
  'profile.underprocess': 'In Elaborazione',
  'profile.fullname': 'Nome e Cognome',
  'profile.airlinemarkup': 'Markup di Compagnia Aerea',
  'profile.airlinename': 'Nome di Compagnia Aerea',
  'profile.airlinetype': 'Tipo di Compagnia Aerea',
  'profile.quota': 'Quota',
  'profile.markup': 'Mark Up',
  'profile.savequota': 'Salva Quota',
  'profile.currency': 'Moneta',
  'profile.passportNumber': 'Numero di passaporto',
  'profile.userPointType': 'Utente',
  'profile.point': 'Punti',
  'profile.savepoint': 'Salva Punti',
  'profile.userpoint': 'Punto Utente',
  'profile.subject': 'Soggetto',
  'profile.date': 'Assegna data',
  'profile.totaluserpoint': 'Totale Punti Utente',
  'profile.viewdetails': 'Visualizza Dettagli',
  'profile.provider': 'Fornitore',
  'profile.b2brequest': 'Richiesta Servizio',
  'profile.language': 'Lingua',
  'profile.department': 'Dipatimento',
  'profile.adddetail': 'Aggiungi Altri Dettagli (Opzionale)',
  'profile.identityno': "Numero d'Identità",
  'profile.gateway': 'Gateway',
  'profile.hi': 'Ciao',
  'profile.status': 'Stato',
  'profile.approve': 'Approva',
  'profile.dissapprove': 'Disapprova',
  'profile.pending': 'Sospeso',
  'profile.notexitstuser': 'Questo nome utente non esiste',
  'profile.selectrole': 'Per Favore Seleziona il dipartimento e il ruolo',
  'profile.invitesuccessfully': "L'Invito spedito con successo",
  'profile.description': 'Descrizione',
  'profile.filldescription': 'Per favore inserisci la descrizione',
  'profile.dashboard': 'Bacheca',
  'profile.mydashboard': 'Mia Bacheca',
  'profile.saleaccounting': 'Rapporto di vendita',
  'profile.profileaccounts': 'Gestione di Contabilità',
  'profile.commissionmanagement': 'Commissione / Gestione dei Punti',
  'profile.uploadlogo': 'Carica il logo della tua azienda',
  'profile.uploadlicense': 'Carica la tua licenza',
  'profile.deleteprofile': 'Elimina Profilo',
  'profile.airlineCommission': 'Commissione aerea',
  'profile.licensepic': 'foto di licenza',
  'profile.profile': 'profilo',
  'profile.errordelete': 'Non è possibile eliminare questo record',
  'profile.editverification': 'Sei sicuro di eliminare questo profilo',
  'profile.reference': 'Autorità emittentesss',
  'profile.logotitle':
    "Fare clic sull'opzione seguente per modificare il logo dell'azienda",
  'profile.invitedepartment': 'Gentile utente, sei stato invitato al ',
  'profile.inviteprofile': ' dipartimento in ',
  'profile.inviterole': ' profilo aziendale con la posizione di ',
  'profile.invite': ".Se lo desideri, conferma l'invito.",
  'profile.countercommission': 'Contro Commissione',
  'profile.ownercommission': 'Commissione del proprietario',
  'profile.bankaccounttype': 'tipo di conto bancario',
  'profile.customermanagement': 'Gestione dei clienti',
  'profile.active': 'Attiva',
  'profile.disactive': 'Disattivare',
  'profile.Individual': 'Individuale',
  'profile.bussiness': 'Attività commerciale',
  'profile.postalcode': 'codice postale',
  'profile.fax': 'Fax',
  'profile.accountingcode': 'Codice contabile',
  'profile.deletecustomer': 'Elimina cliente',
  'profile.insertcustomer': 'Inserisci cliente',
  'profile.updatecustomer': 'Aggiorna cliente',
  'profile.both': 'tutti e due',
  'profile.reload': 'Ricaricare',
  'profile.reloadfilter': 'Ricarica il filtro',
  'profile.isbusiness': 'È affari',
  'profile.isactive': 'È attivo',
  'profile.name': 'nome',
  'profile.registerdate': 'Data di registrazione',
  'profile.chargewallet': 'Carica il tuo portafoglio',
  'profile.currentcredit': 'Credito attuale',
  'profile.amount': 'Importo della carica',
  'profile.chargecreditmessgae':
    'Carica il tuo portafoglio per acquistare più facilmente e in sicurezza.',
  'profile.credit': 'Credito :',
  'profile.paymentdate': 'Data di pagamento',
  'profile.gotowalletpage': 'Torna per caricare il portafoglio',
  'profile.notfound': 'Nessun record trovato',
  'profile.message': 'Messaggio',
  'profile.mypoint': 'Il mio punto',
  'profile.wallet': 'portafoglio',
  'profile.chooseRole': 'Scegli un ruolo',
  'profile.commission': 'commissione',
  'profile.addQuota': 'aggiungi quota',
  'profile.newQuota': 'Nuova quota',
  'profile.mycredit': 'Il mio credito',
  'profile.departmentmanagement': 'Direzione del reparto',
  'profile.customerphrase': 'Nome completo / codice contabile',
  'profile.enterusername': 'Immettere il nome utente desiderato',
  'profile.menucredit': 'Credito :',
  'profile.personalprofile': 'Profilo individuale',
  'profile.employeesearch': 'Cerca per nome, cognome e cellulare',
  'profile.gotowalletpage': 'torna alla pagina di addebito del portafoglio',
  'profile.documentdescription': 'Descrizione del documento',
  'profile.documentnumber': 'Numero del documento',
  'profile.registertime': 'Tempo di registrazione',
  'profile.pointtransaction': 'Transazione punto',
  'profile.buypoints': 'Acquista punto',
  'profile.price': 'Prezzo',
  'profile.errorsecondpassword':
    'La seconda password e la ripetizione della seconda password non sono la stessa cosa',
  'profile.successsecondpassword':
    'La seconda password è stata salvata con successo',
  'profile.insertinformation': 'Inserisci informazioni',
  'profile.businessprofile': 'Profilo aziendale',
  'profile.creditmanagement': 'Gestione Crediti',
  'profile.affiliateMarketing': 'Marketing Di Affiliazione',
  'profile.account': 'account',
  'profile.individual': 'individuo',
  'profile.business': 'attività commerciale',
  'profile.myfriends': 'Miei amici',
  'profile.viewCreditsAndWallets': 'visualizza crediti e portafogli',
  'profile.employeeManagement': 'Gestione dipendenti',
  'profile.customerManagement': 'Gestione clienti',
  'profile.financialmanagement': 'Gestione finanziaria',
  'profile.messagedate': 'Nachricht Datum',
  'profile.startMessagedate': 'Data di inizio del messaggio',
  'profile.endMessagedate': 'Data di fine messaggio',
  'profile.pointsremain': 'Punti Rimangono',
  'profile.messagedescription': 'Descrizione del messaggio',
  'profile.upgradeYourPlan': 'Aggiorna il tuo piano',
  'profile.profileedit': 'MODIFICA PROFILO',
  'profile.licenses': 'Licenze',
  'profile.planCustomer': 'Pianifica cliente',
  'profile.walletremain': 'Il portafoglio rimane',
  'profile.walletbalance': 'Saldo del portafoglio',
  'profile.chargeamount': 'Importo addebito(IRR)',
  'profile.bankreceipt': 'ricevuta bancaria',
  'profile.online': 'in linea',
  'profile.increasebalance': "Aumenta l'equilibrio",
  'profile.selectedbills': 'Fatture selezionate',
  'profile.paymentbills': 'Fatture di pagamento',
  'profile.employeeList': 'Elenco dipendenti',
  'profile.addEmployee': 'Aggiungi dipendente',
  'profile.sendingInvitation': 'Invio invito',
  'profile.employee': 'Dipendente',
  'profile.call': 'Chiama',
  'profile.message': 'Messaggio',
  'profile.increaseOrEditCredentials': 'Aumenta o modifica credenziali',
  'profile.sendToGroup': 'Invia al gruppo',
  'profile.theDesiredRole': 'Il ruolo desiderato',
  'profile.addDepartment': 'Aggiungi reparto',
  'profile.employeeRole': 'Ruolo dipendente',
  'profile.moreDetails': 'Maggiori dettagli',
  'profile.mehdiAbdollahiMehr': 'Mehdi AbdollahiMehr',
  'profile.hiMessage': 'ciao, dove sei?',
  'profile.inWork': 'Inwork',
  'profile.addNew': 'Aggiungi nuovo',
  'profile.reminding': 'Ricorda',
  'profile.participate': 'Partecipa',
  'profile.sportsInteractive': 'Sport interattivo',
  'profilo.team': 'Squadra',
  'profile.tasks': 'compiti',
  'profile.chooseAnArtist': 'scegli un artista',
  'profile.prepareForACallWithAClient':
    'Preparati per una chiamata con un client',
  'profile.prepareAEKTemplateForTheClient':
    'Prepara un modello EK per il cliente',
  'profile.prepareDetiledBrief':
    'Preparare un brief dettagliato per sviluppatori e designer 04:12',
  'profile.more': 'Altro',
  'profile.position': 'Posizione',
  'profile.employeeInformation': 'Informazioni sui dipendenti',
  'profile.employeeRegistrationDate': 'Data di registrazione del dipendente',
  'profile.creditAmount': 'Importo del credito',
  'profile.theCeilingOfEachPurchase': 'massimale di ogni acquisto',
  'profile.validityDuration': 'Durata validità',
  'profile.creditStatus': 'Stato credito',
  'profile.increaseCredit': 'Aumenta credito',
  'profile.editCredit': 'Modifica credito',
  'profile.employeeCredit': 'Credito dipendente',
  'profile.creditBalance': 'Saldo a credito',
  'profile.aboutme': 'A proposito di me',
  'profile.myfavouritecity': 'Le mie città preferite',
  'profile.loan': 'Prestito',
  'profile.gift': 'Regalo',
  'profile.messageType': 'Tipo di messaggio',
  'profilo.testo': 'Testo',
  'profilo.file': 'File',
  'profile.totalPurchaseAmount': "Importo totale dell'acquisto",
  'profile.topCustomers': 'Clienti migliori',
  'profile.homeAppliancesSeller': 'Venditore di elettrodomestici',
  'profile.pointsInventory': 'Inventario punti',
  'profile.pointCard': 'Carta punti',
  'profile.shoppingList': 'Lista della spesa',
  'profile.customerInformation': 'Informazioni sul cliente',
  'profile.customerRegistrationDate': 'Data registrazione cliente',
  'profile.customerShoppingList': 'Lista della spesa dei clienti',
  'profile.incomeFromTheCustomer': 'Reddito del cliente',
  'profile.companyAddress': 'Indirizzo azienda',
  'profile.nameOfCEO': 'Nome del CEO',
  'profile.registration/priceChange': 'Registrazione / variazione prezzo',
  'profile.printPassengerInvoice': 'Stampa fattura passeggero',
  'profile.registrationPaymentReceipts': 'Registrazione ricevute di pagamento',
  'profile.priceToBuyFromOwner': 'Prezzo per acquistare dal Tripsi',
  'profile.salesPriceCustomer': 'Prezzo di vendita al cliente',
  'profile.salesManager': 'Responsabile vendite',
  'profile.showLess': 'Mostra meno',
  'profile.purchaseRate': 'Tariffa di acquisto',
  'profile.changeTicketSalesRates':
    'Modifica le tariffe di vendita dei biglietti',
  'profile.savePrice': 'Salva prezzo',
  'profile.remainingAmount': 'Importo residuo',
  'profile.firstPayment': 'Primo pagamento',
  'profile.settlementOfTickets': 'Regolazione dei biglietti',
  'profile.totalAmount': 'Importo totale',
  'profile.attachedPaymentReceipt': 'Ricevuta di pagamento allegata',
  'profile.attachedPaymentReceipt1': 'Prima ricevuta allegata',
  'profile.attachedPaymentReceipt2': 'Seconda ricevuta allegata',
  'profile.attachedPaymentReceipt3': 'Terza ricevuta allegata',
  'profile.attachedPaymentReceipt4': 'Quarta ricevuta allegata',
  'profile.attachedPaymentReceipt5': 'Quinta ricevuta allegata',
  'profile.totalRemaining': 'Totale rimanente',
  'profile.saveAndNextReceipt': 'Salva e prossima ricevuta',
  'profile.saveAndExit': 'Salva ed esci',
  'profile.travel': 'Viaggiare',
  'profile.editconfirmation':
    "Inviando una richiesta di modifica, il tuo profilo verrà sospeso fino a quando non sarà approvato da Tripsi. Sei d'accordo?",
  'profile.searchtobuy': 'Rapporto ricerca per acquistare',
  'profile.me': 'Tell about yourself.Get points',
  'profile.listOfPassengers': 'Elenco dei passeggeri',
  'profile.customer': 'cliente',
  'profile.addcity': 'Aggiungi città',
  'profile.showinfo': 'Mostra informazioni',
  'profile.editPassengerInformation': 'Modifica informazioni passeggero',
  'profile.yourPassengerHasBeenSuccessfullyRegistered':
    'Il tuo passeggero è stato registrato con successo',
  'profile.theRequestedPassengerInformationWasSuccessfullyEdited':
    'Le informazioni sul passeggero richieste sono state modificate con successo',
  'profile.customerSuccessfullyRegistered': 'Cliente registrato con successo',
  'profile.theDesiredCustomerInformationWasSuccessfullyEdited':
    'Le informazioni sul cliente desiderate sono state modificate con successo',
  'profile.addfriend': 'Aggiungi amico',
  'profile.inveitefriend': 'Invita gli amici',
  'profile.editEmployeeSuccessfully': 'Modifica dipendente riuscita',
  'profile.updateEmployeeSuccess':
    'Le informazioni sul dipendente sono state modificate con successo',
  'profile.mostSales': 'La maggior parte delle vendite',
  'profile.theLowestNumberOfSales': 'Vendite più basse',
  'profile.mostSalesAmount': 'Importo della maggior parte delle vendite',
  'profile.theLowestSalesAmount': "L'importo di vendita più basso",
  'profile.startTravelDate': 'data di viaggio da',
  'profile.endTravelDate': 'data del viaggio verso',
  'profile.mostActivityTime': 'La maggior parte del tempo di attività',
  'profile.minimumActivityTime': 'Tempo minimo di attività',
  'profile.employeeActivities': 'Attività dei dipendenti',
  'profile.applyChanges': 'ََApplica modifiche',
  'profile.planPassenger': 'Pianifica passeggero',
  'profile.all': 'tutti',
  'profile.Activities': 'attività',
  'profile.allProfiles': 'profili',
  'profile.allStatuses': 'Stati',
  'profile.dragtoadd': 'Trascina per aggiungere',
  'profile.dragtotransfer': 'Trascina per trasferire',
  'profile.alltransactions': 'Tutte le transazioni',
  'profile.changedate': 'Cambia data',
  'profile.allusers': 'Tutti gli utenti',
  'profile.recentTravels': 'Viaggi recenti',
  'profile.mounthReport': 'Leistungsbericht des letzten Monats',
  'profile.recentNews': 'Report sulle prestazioni dellultimo mese',
  'profile.tourismNews': 'notizie turistiche',
  'profile.recentMonthActivitie': 'attività dellultimo mese',
  'profile.donutChart': 'viaggi fatti',
  'profile.NumberFlightPurchases': 'Numero di acquisti di voli',
  'profile.NumberFlightSearches': 'Numero di prenotazioni di voli',
  'profile.text': 'Testo',
  'profile.file': 'File',
  'profile.agree': 'Concordare',
  'profile.changeLogo': 'Cambia logo',
  'profile.editingInformation': 'Info sulla modifica',
  'profile.webSite': 'Sito web',
  'profile.presensnt': 'peresente',
  'profile.absence': 'assenza',
  'profile.leave': 'partire',
  'profile.inviteEmployees': 'invitare i dipendenti',
  'profile.textEmployees':
    "Attraverso il modulo sottostante, puoi inviare inviti ai dipendenti che hanno lasciato l'azienda e che hanno nomi utente attivi e loro alla tua collezione .",
  'profile.addEmployees': 'aggiungi Dipendenti',
  'profile.textAddemplo':
    'Attraverso il form sottostante è possibile inserire nuovi dipendenti in azienda e monitorare le loro prestazioni attraverso varie funzionalità del sistema .',
  'profile.copy': 'copiato',
  'profile.editEmployeeInformation': 'Modifica le informazioni sui dipendenti',
  'profile.purchases': 'acquisti',
  'profile.addCustomer': 'Aggiungi cliente',
  'profile.textCustomer':
    'Attraverso il seguente modulo, puoi aggiungere alla collezione i tuoi clienti desiderati completando le seguenti informazioni .',

  'profile.customerList': 'Elenco clienti',
  'profile.services': 'I nostri servizi',
  'profile.tourManagement': 'Gestione del tour',
  'profile.onlineFriend': 'i miei amici in linea',
  'profile.reservations': 'Prenotazioni',
  'profile.row': 'riga',
  'profile.transactions': 'Transazioni',
  'profile.searchHistory': 'Cronologia delle ricerche',
  'profile.Transactions': 'finanziarie',
  'profile.Invoices': 'Fatture',
  'profile.assetManagment': 'Gestione delle risorse',
  'profile.transaction': 'Transazioni',
  'profile.Invoice': 'Fattura',
  'profile.Invite': 'Invitare',
  'profile.add': 'Inserisci',
  'profile.passengers': 'Passeggeri',
  'profile.messages': 'Messaggi',
  'profile.Services': 'Servizi',
  'profile.messageNo': 'Numero del messaggio',
  'profile.viewInvoice': 'Visualizza la fattura',
  'profile.flight': 'volo',
  'profile.paid': 'Pagato',
  'profile.unpaid': 'Non Pagato',
  'profile.choosefile': 'Scegli file',
  'profile.sellername': `Nome del venditore`,
  'profile.factoreno': 'Fattore n',
  'profile.customername': 'Nome del cliente',
  'profile.phonenumber': 'Numero di cellulare',
  'profile.printinvoice': 'Stampa fattura',
  'profile.signature': 'Timbro contabile e firma',
  'profile.signaturetext':
    'Senza sigillo e firma, la contabilità non è valida.',
  'profile.servicedescription': 'Descrizione del servizio',
  'profile.taxesduties': 'Tasse e dazi',
  'profile.purchaseamount': `Ammontare dell'acquisto`,
  'profile.friendsearch': 'Nome, codice nazionale, passaporto n',
  'profile.ticketsearch': 'Titolo, biglietto n',
  'profile.messagesearch': 'Oggetto, messaggio n',
  'profile.bookingflightsearch': `Nome, numero d'ordine`,
  'profile.transactionsearch': `Nome, numero d'ordine`,
  'profile.employeesearch': 'Nome, e-mail',
  'profile.customersearch': 'Nome del cliente',
  'profile.passangersearch': 'Nome, codice nazionale, passaporto n',
  'profile.activities': 'Attività',
  'profile.addlicenselink': 'Aggiungi licenza',
  'profile.startnewsevent': 'Inizia evento',
  'profile.endnewsevent': 'Fine evento',
  'profile.descriptionnews': 'Testo della notizia:',
  'profile.introduction': 'Introduzione',
  'profile.firsttravel': 'Aspettando il Primo Viaggio...',
  'profile.transactionnumber': 'Codice transazione :',
  'profile.notfoundnews': 'Notizie non trovate',
  'profile.notfoundtravel': `Non hai ancora viaggiato.`,
  'profile.waitingTrip': 'Aspettiamo il vostro primo viaggio...',
  'profile.addLicenseText':
    'Tramite il modulo sottostante potrai inserire i tuoi permessi e registrare le informazioni alla fine.',
  'profile.simpleuser': 'Utente normale',
  'profile.owner': 'Proprietaria',
  'profile.crm': 'CRM',
  'profile.counter': 'Contatrice',
  'profile.accountants': 'Ragionieri',
  'profile.roles': 'Ruoli',
  'profile.submitchangerate': 'La modifica del tasso di vendita è riuscita',
  'profile.paymentprice': 'prezzo del pagamento',
  'profile.savesuccessfully': 'Salva con successo',
  'profile.viewfile': 'Visualizza file',
  'profile.backgammon': 'Backgammon',
  'profile.chatgpt': 'Chat GPT',
  'profile.calendar': 'Calendario',
  'profile.game': 'Gioco',
  'profile.addgateway': 'Aggiungi percorso di volo',
  'profile.editgateway': 'Modifica percorso di volo',
  'profile.addgatewaydescription':
    'In questo modulo puoi registrare il percorso di volo desiderato. Dopo la registrazione, le ricerche verranno effettuate in base ai percorsi di volo registrati',
  'profile.editgatewaydescription':
    'In questo modulo puoi modificare il percorso di volo desiderato. Dopo la modifica, le ricerche verranno effettuate in base ai percorsi di volo registrati',
  'profile.gatewayroutes': 'Percorsi di volo',
  'profile.airlinecode': 'Codice della compagnia aerea',
  'profile.internalcode': 'Codice interno',
  'profile.weekdays': 'Giorni della settimana',
  'profile.known': 'Conosciuto',
  'profile.unknown': 'Sconosciuto',
  'profile.airlinestatus': 'Stato della compagnia aerea',
  'profile.allroutes': 'Tutti i percorsi',
  'profile.selectoriginanddestination': 'Seleziona origine e destinazione',
  'profile.siti': 'Siti',
  'profile.sito': 'Sito',
  'profile.soti': 'Soti',
  'profile.soto': 'Soto',
  'profile.pathchoice': 'Scelta del percorso',
  'profile.submiteditgateway': 'Conferma modifica percorso',
  'profile.submitaddgateway': 'Conferma aggiunta percorso',
  'profile.selectflightsdays': 'Seleziona giorni di volo',
  'profile.departureflightcity': 'Città di partenza del volo',
  'profile.arrivalflightcity': 'Città di arrivo del volo',
  'profile.ascinternalcode': 'Ordine crescente del codice interno',
  'profile.descinternalcode': 'Ordine decrescente del codice interno',
  'profile.ascairlinecode': 'Ordine crescente del codice della compagnia aerea',
  'profile.descairlinecode':
    'Ordine decrescente del codice della compagnia aerea',
  'profile.addgatewaysuccessfully': 'Percorso di volo registrato con successo',
  'profile.editgatewaysuccessfully': 'Percorso di volo modificato con successo',
  'profile.notallowed':
    'Non consente di selezionare il profilo prima di approvarlo',
  'profile.addcustomerduplicated': 'Il cliente desiderato è già registrato',
  'profile.loading': 'Caricamento...',
  'profile.textAddfriend':
    'Puoi inviare un invito ai tuoi amici tramite il seguente modulo e aggiungerli alla tua lista di amici.',
  'profile.reservations': 'Prenotazioni',
  'profile.clubCard': 'Tessera Club',
  'profile.Invoices': 'Fatture',
  'profile.textEditingTripsi':
    'Puoi modificare le informazioni del tuo profilo tramite il modulo sottostante. Tieni presente che una volta apportate le modifiche, il profilo verrà sospeso per essere approvato da Tripsi.',
  'profile.textEditingTripord':
    'Puoi modificare le informazioni del tuo profilo tramite il modulo sottostante. Tieni presente che una volta apportate le modifiche, il profilo verrà sospeso per essere approvato da Tripord.',
  'profile.textPassword':
    'Puoi modificare la tua password e definirne una nuova tramite il modulo sottostante.',
  'profile.textDepartment':
    'È possibile registrare o reindirizzare il reparto desiderato tramite il modulo sottostante.',
  'profile.transferType': 'Tipo di trasferimento',
  'profile.transferamount': 'Importo del trasferimento',
  'profile.sendfile': 'Invia ricevuta bancaria',
  'profile.sendfiles': 'Invia ricevute bancarie',
  'profile.factorestartdate': 'Data inizio fattura',
  'profile.factoreenddate': 'Data fine fattura',
  'profile.factoredate': 'Data della fattura',
  'profile.allfactors': 'Tutte le fatture',
  'profile.walletnotenough': 'Il saldo del portafoglio non è sufficiente',
  'profile.approvePrice': 'Prezzo Approvato',
  'profile.oldsecondpassword': 'Vecchia seconda password',
  'profile.setSecondPasswordInfo':
    'Se stai impostando la seconda password per la prima volta, non è necessario inserire questo campo.',
};
